import type { ListsQueryFactory } from "./types";

export const STATIC_LISTS_QUERY_KEY = "staticList:lists";
export const SAVED_SEARCHES_LISTS_QUERY_KEY = "savedSearches:lists";

export const listsQueryKeys: ListsQueryFactory = {
    allStaticLists(): readonly string[] {
        return [STATIC_LISTS_QUERY_KEY];
    },
    staticLists(page: number, searchText: string): readonly string[] {
        return [STATIC_LISTS_QUERY_KEY, page.toString(), searchText];
    },
    savedSearches(searchText: string, page?: number): readonly string[] {
        return [SAVED_SEARCHES_LISTS_QUERY_KEY, (page || "").toString(), searchText];
    },
    allSavedSearches(): readonly string[] {
        return [SAVED_SEARCHES_LISTS_QUERY_KEY];
    },
};
